import React from 'react'
import { dollarToString } from '../../../lib/currency-utils';
import { DashboardTable } from '../dashboard-table';

const renderAggregateTable = (title, aum, fee, fee_mtd) => {
    const title_item = strs => {
        const style = {
        fontWeight: "bold",
        paddingRight: "1rem",
        }
        const str_0 = strs.length > 1 ? strs[0] : " ";
        const str_1 = strs.length > 1 ? strs[1] : strs[0];
        return (
        <div style={style}>
            <div style={{height: "1rem", marginBottom: "0.2rem"}}>{str_0}</div>
            <div>{str_1}</div>
        </div>
        )
    }
    const div_style = {
        padding: "0.5rem, 0"
    }
    const aum_usd = aum ? aum.usd : 0;
    const data = [
        [
        title_item(["AUM", aum.date]),
        title_item(["Advisory Fee", fee._date]),
        title_item(["Advisory Fee", "MTD"]),
        title_item(["Sub Advisory Fee", fee._date]),
        title_item(["Sub Advisory Fee", "MTD"]),
        ],
        [
        (<div style={div_style}>{dollarToString(aum_usd)}</div>),
        (<div style={div_style}>{dollarToString(fee && fee.advisor.curr_usd)}</div>),
        (<div style={div_style}>{dollarToString(fee_mtd && fee_mtd.advisory_usd)}</div>),
        (<div style={div_style}>{dollarToString(fee && fee.sub_advisor.curr_usd)}</div>),
        (<div style={div_style}>{dollarToString(fee_mtd && fee_mtd.sub_advisory_usd)}</div>),

        ]
    ];

    const styles = [
        {
        pred: row => row === 0,
        style: {
            borderBottom: "solid 1px black",
        }
        }
    ]

    return (
        <div style={{display: "flex", marginBottom: "2rem"}}>
        <div style={{fontSize: "1.5rem", fontWeight: "bold", width: "10rem"}}>{title}</div>
        <div style={{width: "2rem"}}/>
        <DashboardTable
            tableStyle={{margin: "0", width: "60rem"}}
            tdStyleLut={styles}
            data={data}/>
        </div>
    );
}

const AssetsUnderManagement = ({ title, wlf }) => {
    const { aum, fee, fee_mtd } = wlf;

    return <div>{renderAggregateTable(title, aum, fee, fee_mtd)}</div>
}

export default AssetsUnderManagement